import { render, staticRenderFns } from "./AdminSalesDetail.vue?vue&type=template&id=761c2d24&scoped=true&"
import script from "./AdminSalesDetail.vue?vue&type=script&lang=js&"
export * from "./AdminSalesDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminSalesDetail.vue?vue&type=style&index=0&id=761c2d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761c2d24",
  null
  
)

export default component.exports